export function getTotalPages(count: number, rowsPerPage: number) {
  return Math.ceil(count / rowsPerPage);
}
